exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-panel-stage .panel-wrap,.tab-panel-stage.theme-default .panel-wrap{padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/common/tab-panel/tab-panel.scss
// module id = 588
// module chunks = 2